import React, { useContext } from 'react'
import {
  SESSION_TIMEOUT_MESSAGE,
  ENVIRONMENT_VARIABLES,
  LOGIN_APP_URL,
  GO_TO_LOGIN_BUTTON_LABEL,
} from '~utils/constants'
import { Button } from '@connectcore/connect-components-react'
import { useHistory } from 'react-router-dom'
import CustomSkeletonLoader from '~components/CustomSkeletonLoader/CustomSkeletonLoader'
import { IUserContextType, UserContext } from '~utils/context/UserContext'
import { checkPingTokenExpiry } from '~utils/forgerock'
import './SessionExpire.scss'

const SessionExpire = props => {
  const { isLoading, storeToken, setStep, setIsLoading, env, pingTokenTimeout, showErr } =
    useContext(UserContext) as IUserContextType
  const history = useHistory()
  const token = storeToken ? storeToken : props.token
  const gotoLogin = () => {
    if (checkPingTokenExpiry() || pingTokenTimeout || showErr) {
      window.location.replace(ENVIRONMENT_VARIABLES[env][LOGIN_APP_URL])
    } else {
      setIsLoading(true)
      setStep(undefined)
      history.push({
        pathname: '/',
        state: { storeToken: token },
      })
    }
  }

  return (
    <div className="d-flex flex-column session-timeout mx-auto w-70">
      {isLoading ? (
        <CustomSkeletonLoader />
      ) : (
        <>
          <h2 className="fw-bold my-5 align-self-center"> {SESSION_TIMEOUT_MESSAGE}</h2>
          <br />
          <Button
            kind="primary"
            className="my-3"
            onClick={() => {
              gotoLogin()
            }}
          >
            {GO_TO_LOGIN_BUTTON_LABEL}
          </Button>
        </>
      )}
    </div>
  )
}

export default SessionExpire
